import React, { useState, useEffect, useContext } from "react"
import { JourneyContext } from "../components/context/journeyContext";
// import Loader1 from "../interceptors/loader-interceptor"
import { getBranchList, getBranchRm } from "../services/rm-led-service"
import { fetchDomain,getIpAddress,getJWTTokenForIp, hsbcBankIntegration } from "../services/apiservice"
import * as lookup from "../../static/lookup.json";
import { navigate } from "gatsby"
import { refreshToken } from "../interceptors/jwt-interceptor";
import { DataLayerIntegration } from "../components/services/helperFunctions";
import journeyssr from "../../static/journeyssr.json"


export default function Rmled(props) {
  const [allBranchdata, setAllBranchData] = useState([])
  // const [journeyState,setJourneyState] = useContext(JourneyContext)
  const [corpDiscountParam, setcorpDiscountParam] = useState("")
  const [allRm, setAllRm] = useState([])
  const [isRMVisible, setisRMVisible] = useState(false)
  const [customerData, setCustomerData] = useState({})

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const source = urlParams.get("source")
    if (source === "hsbc"){
      const customerId = urlParams.get("hsbc_id")
      if (customerId){
        let payload = {
          customerId
        }
        hsbcBankIntegration(payload)
        .then(res => {
          props.setHsbcBankData(res)
        })
        .catch(err => {
          console.log(err)
        }) 
      }
    }
  },[])

  useEffect(async () => {

    // const urlParams = new URLSearchParams(window.location.search)
    // let urlPart  =window.location.search.toLowerCase()
    // if(urlPart.includes('hsbc')){
    //   document.body.style.backgroundColor = "#ededed";
    // }
    try {
      const res = await getBranchList("HSBC");
      const data = res.data?.data;
      setAllBranchData([...data])
      setisRMVisible(true)
    } catch (error) {
      console.log(error)
    }
  }, [])


  useEffect(()=>{
    const urlParams = new URLSearchParams(props.location.search)
    setcorpDiscountParam(urlParams.get("CSIDPROC")?.toUpperCase())
  },[props.location.search])


  useEffect(() => {
    if (props.channel && corpDiscountParam === "Y") {
      getIpAddress()
        .then(async res => {
          let payload = {
            ip: res.IPv4
          }
          if (refreshToken) {
            let payloadToFetchDomains = {
              channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
            }
            let domains = await fetchDomain(payloadToFetchDomains)
            console.log(domains, "domains")
            if((domains.domain).length === 0){
              navigate("/invalidChannel")
             }
            // setJourneyState(prev => {
            //   return ({
            //     ...prev,
            //     corpDiscDomains: domains.domain || []
            //   })
            // })

          } else {
            getJWTTokenForIp(payload)
              .then(async res => {
                let payloadToFetchDomains = {
                  channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
                }
                let domains = await fetchDomain(payloadToFetchDomains)
                console.log(domains, "domains")
                if((domains.domain).length === 0){
                  navigate("/invalidChannel")
                }
                // setJourneyState(prev => {
                //   return ({
                //     ...prev,
                //     corpDiscDomains: domains.domain || []
                //   })
                // })
              })
          }
        })
    }
  }, [props.channel, corpDiscountParam])

  const [radio1, setRadio1] = useState("one")
  const [localValues, setLocalValues] = useState({
    branchName: "",
    relationshipManager: "",
  })
  const [showError, setShowError] = useState(false)

  const handleRadioChange = value => {
    setRadio1(value)
  }

  const handleChange = async ({ target }, value) => {
    console.log(target.value, value, "handle change target and value")

    if (value === "branch") {
      setLocalValues(prev => {
        return {
          ...prev,
          branchName: target.value,
        }
      })
      setAllRm([])
      try {
        const payload = {
          BRANCH_ID: target.value,
          CHANNEL_ID: "HSBC",
        }
        const res = await getBranchRm(payload)
        const data = res.data?.data[0]
        setAllRm([...data])
      } catch (error) {
        console.log(error)
      }
    } else if (value === "relation") {
      setLocalValues(prev => {
        return {
          ...prev,
          relationshipManager: target.value,
        }
      })
    }
  }

  let S2SparamExists = false;
  let S2SParamValue = null;
  let S2SParam = null
  
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    S2SParam = urlParams.has("isnpS2S");
    S2SParamValue = urlParams.get("isnpS2S");
    S2SparamExists = S2SParamValue === 'Y' ? true : false;
  }
  const handleSubmit = e => {
    e.preventDefault()
    if (radio1 === "two") {
      if (localValues.branchName === "") {
        setShowError(true)
      } else if (localValues.relationshipManager === "") {
        setShowError(true)
      } else {
        let agentDetails = allRm.find(element => element["LEVEL1_ID_SP"] === localValues.relationshipManager)
        let branchDetails = allBranchdata[0]?.find(element => element["BRANCH_ID"] === localValues.branchName)
        // console.log(agentDetails, branchDetails, "ffijfji1" )
        let rmData = {...agentDetails, ...branchDetails}
        console.log(rmData, "ffijfji2")

        setShowError(false)
        props.isJourneyStart(rmData)
        DataLayerIntegration({},"","rmLed","submit",{
          journeyIdFromStrapi : "Promise2ProtectJourney"
        })
      }
    } else {
      setShowError(false)
      props.isJourneyStart({})
      let a = journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId
      console.log(journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId);
      if(lookup?.fnaValidPlans?.includes(journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId)){
        const state = { isnpS2S: 'Y' };

        let baseUrl = S2SParamValue==='Y'?`${process.env.GATSBY_FNA_LINK}` + `?isnpS2S=${encodeURIComponent(state.isnpS2S)}`:`${process.env.GATSBY_FNA_LINK}`;

        // Get current URL params
        const urlParams = new URLSearchParams(window.location.search);
        const hsbcId = urlParams.get("hsbc_id");

        if (hsbcId && props.hsbcBankData) {
          // Check if URL already has "?" (query params exist)
          const separator = baseUrl.includes("?") ? "&" : "?";
          console.info("separator",separator)
          baseUrl += `${separator}hsbc_data=${btoa(encodeURIComponent(JSON.stringify(props.hsbcBankData)))}`;
        }

        window.location.href = baseUrl;

      }else{
        return
      }
    }
  }

  useEffect(() => {
    DataLayerIntegration({},"","rmLed","landing",{
        journeyIdFromStrapi : "Promise2ProtectJourney"
    })
  },[])

  return (
    <>
      {isRMVisible ? (
        <div className="Q4-option2-design-structure" style={{ backgroundColor:"transparent"}} >
          <div className="container">
            <div className="iselect-box-design">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">
                    PLEASE ENTER DETAILS TO CONTINUE
                  </h1>
                </div>
              </div>

              <div className="iselect-mg-bottom mt-10">
                <div className="col-md-12 pl">
                  <div className="row iselect-mg-bottom q2-space-de" style={{"marginLeft":"0px"}}>
                    <div className="col-md-6 col-sm-6 at1-text active pl pr-30">
                      <div className="radio-line check-rt">
                        <label className="customradio">
                          <div
                            className={`option-buit-design-new-structure-sde-box Q4-option-list-structure1 ${
                              radio1 === "one" ? "active" : ""
                            }`}
                          >
                            {" "}
                            <span className="radiotextsty"></span>
                            <input
                              type="radio"
                              defaultChecked
                              name="radio1"
                              onChange={() => handleRadioChange("one")}
                            />
                            <span className="check-premium-payment checkmark">
                              <span className="fa fa-check check11"></span>
                            </span>
                            <div className="Q4-option-list-structure1-headline">
                              <p>
                                I am purchasing this product on my own volition,
                                without recommendation by an HSBC India
                                Relationship Manager basis Goal Planning
                                journey.
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6 at1-text active pr pl-30">
                      <div className="radio-line check-rt">
                        <label className="customradio">
                          <div
                            className={`option-buit-design-new-structure-sde-box Q4-option-list-structure2 ${
                              radio1 === "two" ? "active" : ""
                            }`}
                          >
                            {" "}
                            <span className="radiotextsty"></span>
                            <input
                              type="radio"
                              name="radio1"
                              onChange={() => handleRadioChange("two")}
                            />
                            <span className="check-premium-payment checkmark">
                              <span className="fa fa-check check11"></span>
                            </span>
                            <div className="Q4-option-list-structure1-headline">
                              <p>
                                I am purchasing this product pursuant to
                                recommendation by an HSBC India Relationship
                                Manager basis Goal Planning journey.
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <form>
                {radio1 === "two" && (
                  <div className="iselect-padding if-yes" id="div3" style={{"marginLeft":"14px"}}>
                    <div className="row iselect-mg-bottom mt-20">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label"> Branch Name </label>
                          <select
                            className="select2 form-control"
                            name="a1"
                            value={localValues.branchName}
                            onChange={e => handleChange(e, "branch")}
                          >
                            <option value="">Select</option>
                            {allBranchdata[0].map(
                              (ele, index) =>
                                ele.BRANCH_ID &&
                                typeof ele.BRANCH_ID === "string" &&
                                ele.BRANCH_LOCATION &&
                                typeof ele.BRANCH_LOCATION === "string" && (
                                  <option
                                    key={ele.BRANCH_ID}
                                    value={ele.BRANCH_ID}
                                  >
                                    {ele.BRANCH_LOCATION}
                                  </option>
                                )
                            )}
                          </select>
                        </div>
                        {showError && localValues.branchName === "" && (
                          <div>
                            <label id="a1-error" className="error" for="a1">
                              Please select Branch Name
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 col-xs-12 all-box-padding-left">
                        <div className="form-group input-group">
                          <label className="title-bg inp-label">
                            Relationship Manager
                          </label>
                          <select
                            className="select2 form-control"
                            name="a2"
                            value={localValues.relationshipManager}
                            onChange={e => handleChange(e, "relation")}
                          >
                            <option value="">Select</option>
                            {allRm.map(
                              (ele, index) =>
                                ele.JV_RM_ID && ele.LEVEL1_ID_SP &&
                                typeof ele.JV_RM_ID === "string" && typeof ele.LEVEL1_ID_SP === "string" &&
                                ele.LEVEL1_NAME &&
                                typeof ele.LEVEL1_NAME === "string" && (
                                  <option
                                    key={ele.LEVEL1_ID_SP}
                                    value={ele.LEVEL1_ID_SP}
                                  >
                                    {ele.LEVEL1_ID_SP}
                                  </option>
                                )
                            )}
                          </select>
                        </div>
                        {showError && localValues.relationshipManager === "" && (
                          <div>
                            <label id="a2-error" className="error" for="a2">
                              Please select Relationship Manager
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="iselect-mg-bottom pd40">
                  <div className="col-md-12">
                    <div className="but-center text-right">
                      {/* <div className="submit-btn cen">
                        {" "}
                        <a>Previous</a>{" "}
                      </div> */}

                      <input
                        className="previous-btn cen"
                        style={{
                          color: "white",
                          padding: "14px 50px",
                          border: "none",
                        }}
                        type="submit"
                        value="Submit"
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </form>
              <div className="clearfix"></div>
              <div className="col-md-12 mt-30">
                <div className="note-detaile">
                  <h3 className="text-uppercase" style={{ fontWeight: "bold" }}>
                    {" "}
                    Note:
                  </h3>
                  <p>
                    {" "}
                    Please ensure your details provided in the application form match with your HSBC India Bank records. The payment for
                    this purchase needs to be done through your HSBC India Debit card, Credit card and Net Banking only.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  )
}
